/**
 * Created by wuyanbin on 2019/11/22
 */
import React, { Component } from 'react';
import YearArea from './_components/YearArea';
import QuarterArea from './_components/QuarterArea';
import style from './index.less';
import { DatePicker } from 'antd';
// 使用了DatePicker的样式类名
// @ts-ignore
const { MonthPicker } = DatePicker;
// 获取当前月份的季度
function getQuarter() {
    return Math.floor((new Date().getMonth() + 3) / 3);
}
;
class QuarterPicker extends Component {
    constructor(props) {
        super(props);
        // 输入框获取焦点
        this.handlePickerModal = () => {
            this.setState({
                showQuarterPanel: !this.state.showQuarterPanel,
            }, () => {
                this.handlePickerDefaultVal(this.props.value);
            });
        };
        // 年份的修改
        this.handleYearChange = (type) => {
            const currentYear = this.state.currentYear;
            const disableAfterQuarter = this.props.disableAfterQuarter;
            this.setState({
                currentYear: type === 'after' ?
                    currentYear + 1 : currentYear - 1,
            }, () => {
                disableAfterQuarter && this.disableAfterQuarter();
            });
        };
        /**
         * 处理年份/季度 时间禁止
         * currentYear(当前选择) > nowYear(真实年份) ==> disables = true
         * currentYear(当前选择) == nowYear(真实年份) ==> 禁止掉当前季度
         * currentYear(当前选择) < nowYear(真实年份) ==> disables = false
         */
        this.disableAfterQuarter = () => {
            const nowYear = new Date().getFullYear();
            const currentSelYear = this.state.currentYear;
            const tempList = [];
            this.state.quarterList.map((item) => {
                Object.assign(item, { disabled: false });
                if (currentSelYear > nowYear) {
                    Object.assign(item, { disabled: true });
                }
                else if (currentSelYear === nowYear) {
                    if (getQuarter() <= item.value) {
                        Object.assign(item, { disabled: true });
                    }
                }
                else {
                    Object.assign(item, { disabled: false });
                }
                tempList.push(item);
            });
            this.setState({
                quarterList: tempList,
            });
        };
        // 处理选择器默认值
        this.handlePickerDefaultVal = (val) => {
            const defaultValue = val;
            const disableAfterQuarter = this.props.disableAfterQuarter;
            const nowYear = new Date().getFullYear();
            const currentSelYear = this.state.currentYear;
            // 季度 处理为当前值
            const tempList = [];
            this.state.quarterList.map((item) => {
                Object.assign(item, { selected: false });
                if (disableAfterQuarter && currentSelYear >= nowYear && getQuarter() <= item.value) {
                    Object.assign(item, { disabled: true });
                }
                if (defaultValue.quarter === item.value) {
                    Object.assign(item, { selected: true });
                }
                tempList.push(item);
            });
            this.setState({
                quarterList: tempList,
                currentQuarterValue: defaultValue,
                currentYear: defaultValue.year ? defaultValue.year : new Date().getFullYear(),
            });
        };
        // 季度改变
        this.handleChangeQuarter = (selItem) => {
            const currentSelItem = selItem;
            // 如果禁止，不可修改
            // 否则，遍历 list, 取消其他的选项，将当前的selected : true
            if (currentSelItem.disabled) {
                return;
            }
            const tempList = [];
            this.state.quarterList.map((item) => {
                Object.assign(item, { selected: false });
                if (currentSelItem.value === item.value) {
                    Object.assign(item, { selected: true });
                    this.triggerChange(item);
                }
                tempList.push(item);
            });
            this.setState({
                quarterList: tempList,
                showQuarterPanel: false,
            });
        };
        // Should provide an event to pass value to Form.
        this.triggerChange = (item, isClear = false) => {
            const { onChange } = this.props;
            if (onChange) {
                isClear ? onChange({}) : onChange({ year: this.state.currentYear, quarter: item.value });
            }
        };
        // 渲染日期
        this.renderDate = (val) => {
            return val.year && val.quarter ? `${val.year} 第${val.quarter}季度` : '';
        };
        // 鼠标移入
        this.toggleHover = () => {
            this.setState({ hover: !this.state.hover });
        };
        this.state = {
            hover: false,
            currentQuarterValue: props.value || {},
            currentYear: new Date().getFullYear(),
            showQuarterPanel: false,
            quarterList: [
                {
                    label: '第一季度',
                    value: 1,
                    disabled: false,
                    selected: false,
                },
                {
                    label: '第二季度',
                    value: 2,
                    disabled: false,
                    selected: false,
                },
                {
                    label: '第三季度',
                    value: 3,
                    disabled: false,
                    selected: false,
                },
                {
                    label: '第四季度',
                    value: 4,
                    disabled: false,
                    selected: false,
                },
            ],
        };
    }
    componentDidMount() {
        this.handlePickerDefaultVal(this.props.value);
    }
    componentWillReceiveProps(nextProps) {
        // 处理默认值
        this.handlePickerDefaultVal(nextProps.value);
    }
    // icon calendar
    _renderCalendarIcon() {
        return (<i aria-label="图标: calendar" className="anticon anticon-calendar ant-calendar-picker-icon icon-container">
        <svg viewBox="64 64 896 896" data-icon="calendar" width="1em" height="1em" fill="currentColor" aria-hidden="true" focusable="false">
          <path d="M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zm-40 656H184V460h656v380zM184 392V256h128v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h256v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h128v136H184z"/>
        </svg>
      </i>);
    }
    // clear icon
    _renderClearIcon() {
        return (<div className={style.iconContainer} onClick={(e) => {
            e.stopPropagation();
            this.triggerChange({}, true);
        }}>
        <i aria-label="图标: close-circle" className="anticon anticon-close-circle ant-calendar-picker-icon">
          <svg viewBox="64 64 896 896" focusable="false" data-icon="close-circle" width="1em" height="1em" fill="currentColor" aria-hidden="true">
            <path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm165.4 618.2l-66-.3L512 563.4l-99.3 118.4-66.1.3c-4.4 0-8-3.5-8-8 0-1.9.7-3.7 1.9-5.2l130.1-155L340.5 359a8.32 8.32 0 0 1-1.9-5.2c0-4.4 3.6-8 8-8l66.1.3L512 464.6l99.3-118.4 66-.3c4.4 0 8 3.5 8 8 0 1.9-.7 3.7-1.9 5.2L553.5 514l130 155c1.2 1.5 1.9 3.3 1.9 5.2 0 4.4-3.6 8-8 8z"/>
          </svg>
        </i>
      </div>);
    }
    render() {
        const { showQuarterPanel, currentQuarterValue, currentYear, quarterList, hover } = this.state;
        const { style, placeholder } = this.props;
        return (<div style={{ position: 'relative', display: 'inline-block' }}>
        <span className="ant-calendar-picker" style={style}>
          <div onClick={this.handlePickerModal} onMouseEnter={this.toggleHover} onMouseLeave={this.toggleHover}>
            <input readOnly placeholder={placeholder || '请选择季度'} className="ant-calendar-picker-input ant-input" value={this.renderDate(currentQuarterValue)}/>
            {hover ? this._renderClearIcon() : this._renderCalendarIcon()}
          </div>
        </span>
        {showQuarterPanel &&
            <div>
            
            <div style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                zIndex: 9999,
            }} onClick={this.handlePickerModal}/>
            <div style={{ position: 'absolute', left: 0, top: 0, zIndex: 10000 }} className="ant-calendar-picker-container ant-calendar-picker-container-placement-bottomLeft">
              <div className="ant-calendar">
                <div className="ant-calendar-panel">
                  <div className="ant-calendar-input-wrap">
                    <div className="ant-calendar-date-input-wrap">
                      <input className="ant-calendar-input " placeholder="请选择季度" defaultValue={this.renderDate(currentQuarterValue)} autoFocus={showQuarterPanel}/>
                    </div>
                  </div>
                  <div className="ant-calendar-date-panel">
                    <YearArea currentYear={currentYear} handleYearChange={this.handleYearChange}/>
                    <QuarterArea quarterList={quarterList} handleChangeQuarter={this.handleChangeQuarter}/>
                  </div>
                </div>
              </div>
            </div>
          </div>}
      </div>);
    }
}
export default QuarterPicker;
